import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import { getDuplicateNamesAndAddresses } from 'helpers/people';
import { drugsSupplementalTreatmentAddressNameFields } from 'constants/enums/people';
import { SubstanceDrugsSupplementalUsageModel } from './types';
import substanceDrugsPublicSafetyItemValidator from './validators/item';

const substanceDrugsSupplementalUsageValidator: ValidateJSModel<SubstanceDrugsSupplementalUsageModel> = {
  IllegalControlledSubstanceUseAnswer: { presence: true, hasValue: { validator: hasYesOrNo } },
  IllegalControlledSubstanceUseComment: {},
  IllegalControlledSubstanceUseSummaryComment: {},
  List: (value, attributes, attributeName, options) => {
    if (attributes?.IllegalControlledSubstanceUseAnswer && attributes?.IllegalControlledSubstanceUseAnswer.value === 'Yes') {
      let additionalValidation = {};
      const { errors = [] } = getDuplicateNamesAndAddresses(value?.items, options?.peopleWhoKnowYou, drugsSupplementalTreatmentAddressNameFields);

      if (errors.length > 0) {
        additionalValidation = {
          requireTrue: { // force error message; value will never be true
            message: 'relationships.people.error.duplicateListItems',
          }
        };
      }

      return {
        ...additionalValidation,
        presence: true,
        accordion: { validator: substanceDrugsPublicSafetyItemValidator },
      };
    }
    return {};
  },
};

export default substanceDrugsSupplementalUsageValidator;
